







































import { Testimonial } from 'client-website-ts-library/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Rating from '../UI/Rating.vue';

@Component({
  components: {
    Rating,
  },
})
export default class TestimonialCard extends Vue {
  @Prop()
  private readonly testimonial!: Testimonial;

  private cleanedContent = ''

  mounted() {
    this.cleanContent();
  }

  get formattedAddress(): string {
    const parts = [];

    if (this.testimonial.Address) parts.push(this.testimonial.Address);
    if (this.testimonial.Suburb) parts.push(this.testimonial.Suburb);

    return parts.join(', ');
  }

  @Watch('testimonial')
  cleanContent(): void {
    const el = document.createElement('div');

    el.innerHTML = this.testimonial.Description;

    this.cleanedContent = el.innerText.slice(0, 112);
  }

  popupActive = false

  showTestimonial(): void {
    this.popupActive = true;
  }

  hideTestimonial(): void {
    this.popupActive = false;
  }
}
